// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1F3p1j_9","title":"title-3DhemAnp"};